import axios from 'axios'
import {GlavniIzvjestajModel, IzvjestajFMKWebsoftModel, NalogIzvjestajModel} from '../models/IzvjestajModel'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/paneli/glavniIzvjestaj`
const API2 = `${API_URL}/paneli/glavniIzvjestajV2`
const API_NALOG = `${API_URL}/paneli/izvjestajNaloga`
const API_NALOG_2 = `${API_URL}/paneli/kontrola-kvaliteta/dnevniIzvjestaj`
const API_NALOG_3 = `${API_URL}/paneli/kontrola-kvaliteta/periodicniIzvjestaj`
const API_NALOG_4 = `${API_URL}/paneli/izvjestajKolicinaFmkWebsoft`
const API_UTOVAR_KAMIONA_IZVJESTAJ = `${API_URL}/paneli/utovar-kamiona/izvjestaj`
const API_PROIZVODNJA_PANELA_IZVJESTAJ = `${API_URL}/izvjestaji/proizvodnja-panela`
const API_PROIZVODNJA_PANELA_PO_DRZAVI_IZVJESTAJ = `${API_URL}/izvjestaji/proizvodnja-panela-po-drzavi`
const API_PROIZVODNJA_PANELA_PO_DRZAVI_DETALJI_IZVJESTAJ = `${API_URL}/izvjestaji/proizvodnja-panela-po-drzavi-detalji`
const API_PROIZVODNJA_PANELA_PO_KOMERCIJALISTI_IZVJESTAJ = `${API_URL}/izvjestaji/izvjestaj-po-komercijalisti`
const API_PROSJECNA_DEBLJINA_PANELA_IZVJESTAJ = `${API_URL}/izvjestaji/prosjecna-debljina-panela-tekuca-prosla-godina`
const auth: UposlenikModel = getAuth()!

const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}
export async function getGlavniIzvjestaj(params: any) {
  return await axios.get<Array<GlavniIzvjestajModel>>(API, {headers: headers, params: params})
}
export async function getGlavniIzvjestajV2(params: any) {
  return await axios.get<Array<GlavniIzvjestajModel>>(API2, {headers: headers, params: params})
}
export async function nalogIzvjestaj(params: any) {
  return await axios.get<Array<NalogIzvjestajModel>>(API_NALOG, {headers: headers, params: params})
}

export async function dnevniIzvjestajKontrole(params: any) {
  return await axios.get<Array<NalogIzvjestajModel>>(API_NALOG_2, {headers: headers, params: params})
}

export async function periodicniIzvjestajKontrole(params: any) {
  return await axios.get<Array<NalogIzvjestajModel>>(API_NALOG_3, {headers: headers, params: params})
}

export async function fmkWebsoftIzvjestaj(params: any) {
  return await axios.get<Array<IzvjestajFMKWebsoftModel>>(API_NALOG_4, {headers: headers, params: params})
}

export async function otpremaKamionaIzvjestaj(params: any) {
  return await axios.get(API_UTOVAR_KAMIONA_IZVJESTAJ, {headers: headers, params: params})
}

export async function proizvodnjaPanelaIzvjestaj(params: any, signal?: AbortSignal) {
  return await axios.get(API_PROIZVODNJA_PANELA_IZVJESTAJ, {headers: headers, params: params, signal})
}

export async function proizvodnjaPanelaPoDrzaviIzvjestaj(
  params: {datumOd: string; datumDo: string},
  signal?: AbortSignal
) {
  return await axios.get(API_PROIZVODNJA_PANELA_PO_DRZAVI_IZVJESTAJ, {
    headers: headers,
    params,
    signal,
  })
}

export async function proizvodnjaPanelaPoDrzaviDetaljiIzvjestaj(
  params: {datumOd: string; datumDo: string},
  signal?: AbortSignal
) {
  return await axios.get(API_PROIZVODNJA_PANELA_PO_DRZAVI_DETALJI_IZVJESTAJ, {
    headers: headers,
    params,
    signal,
  })
}

export async function proizvodnjaPanelaPoKomercijalistiIzvjestaj(
  params: {datumOd: string; datumDo: string; partner?: number},
  signal?: AbortSignal
) {
  return await axios.get(API_PROIZVODNJA_PANELA_PO_KOMERCIJALISTI_IZVJESTAJ, {
    headers: headers,
    params,
    signal,
  })
}

export async function prosjecnaDebljinaPanelaIzvjestaj(signal?: AbortSignal) {
  return await axios.get(API_PROSJECNA_DEBLJINA_PANELA_IZVJESTAJ, {
    headers,
    signal,
  })
}
